import React from 'react';
import Type from 'prop-types';

const TabPanel = (props) => {
  const { children, value, active, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== active}
      id={`tabpanel-${index}`}
      aria-labelledby={`tabpanel-${index}`}
      {...other}
    >
      {value === active && children}
    </div>
  );
};

TabPanel.propTypes = {
  active: Type.string.isRequired,
  children: Type.node.isRequired,
  index: Type.oneOfType([Type.string, Type.number]).isRequired,
  value: Type.oneOfType([Type.string, Type.number]).isRequired,
};

export default TabPanel;
